import { useCallback, useContext, useEffect, useState } from 'react';
import { DashboardCommerciauxTableRowProps } from './DashboardCommerciauxTableRow.types';
import { DashboardCommerciauxContext } from '../../DashboardCommerciaux.context';
import { Commercial } from '../../../../../../../types/api/endpoints/commercial/commercial.types';
import Switch from 'react-switch';
import { useMutation, useQueryClient } from 'react-query';
import { BaseResponse } from '../../../../../../../types/api/api.types';
import {
  DISABLE_COMMERCIAL_QUERY_KEY,
  ENABLE_COMMERCIAL_QUERY_KEY,
  disableCommercialQuery,
  enableCommercialQuery,
} from './DashboardCommerciauxTableRow.query';

export default ({ commercial }: DashboardCommerciauxTableRowProps) => {
  const { id, firstName, lastName, email, type, phone, is_enabled } = commercial;

  const queryClient = useQueryClient();

  const { setUpdateModalOpen, setAssignModalOpen, setSelectedCOM } = useContext(DashboardCommerciauxContext);

  const [isChecked, setChecked] = useState(false);

  useEffect(() => {
    if (is_enabled) {
      setChecked(is_enabled)
    }
  }, [is_enabled]);

  const { mutate: enable } = useMutation<Awaited<BaseResponse>, Error, number>(
    (commercialId) => enableCommercialQuery(commercialId),
    {
      mutationKey: ENABLE_COMMERCIAL_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: () => {
        setChecked(true);
      },
      onError: (error) => {
        alert(error.message);
      },
    }
  );

  const { mutate: disable } = useMutation<Awaited<BaseResponse>, Error, number>(
    (commercialId) => disableCommercialQuery(commercialId),
    {
      mutationKey: DISABLE_COMMERCIAL_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: () => {
        setChecked(false);
        setSelectedCOM(commercial);
        setAssignModalOpen(true);
      },
      onError: (error) => {
        alert(error.message);
      },
    }
  );

  const onSwitch = useCallback(
    (checked: boolean) => {
      if (checked) {
        enable(id);
      } else {
        disable(id);
      }
    },
    [id]
  );

  const handleClickCOM = (commercial: Commercial) => {
    setSelectedCOM(commercial);
    setUpdateModalOpen(true);
  };

  return (
    <tr
      className="dashboard-commerciaux__table-tr--clickable"
      onClick={() => handleClickCOM(commercial)}>
      <td>{firstName}</td>
      <td>{lastName}</td>
      <td>{type}</td>
      <td>{email}</td>
      <td>{phone}</td>
      <td onClick={(e) => e.stopPropagation()}>
        <Switch
          onChange={(checked, e) => {
            onSwitch(checked);
            e.stopPropagation();
          }}
          checked={isChecked}
          onColor="#BC2F2A"
          activeBoxShadow="0px 0px 2px 3px #DE5835"
          uncheckedIcon={false}
          checkedIcon={false}
        />
      </td>
    </tr>
  );
};
